export const APP_URL = process.env.REACT_APP_API_URL;
export const APP_BASE_URL = 'https://oneclick.switchmobilityev.com/api';
// export const APP_BASE_URL = 'http://10.103.2.155:8000';
//export const APP_BASE_URL = 'http://10.211.31.16:8000';

// export const APP_BASE_URL = 'https://oneclick.switchmobilityev.com/api';
// export const APP_BASE_URL = 'http://10.103.2.155:8000';
// export const APP_BASE_URL = 'http://10.103.2.121:8000';
//export const APP_BASE_URL = 'http://10.103.2.163:8000/';
// export const APP_BASE_URL = 'http://10.103.2.163:8000/';
//  export const APP_BASE_URL = 'https://oneclick.switchmobilityev.com/api';
// export const APP_BASE_URL = 'http://10.103.2.163:8000';
// export const APP_BASE_URL = 'http://localhost:3000';
//  export const APP_BASE_URL = 'https://oneclick.switchmobilityev.com/api';
 //export const APP_BASE_URL = 'https://oneclick.switchmobilityev.com/api';
// export const APP_BASE_URL = 'http://10.103.2.141:8000';
// export const APP_BASE_URL = 'http://10.103.2.155:8000';

//  export const APP_BASE_URL = 'http://10.103.2.70:3000';

// 10.103.2.70
// 10.103.2.58

//http://127.0.0.1:8000/


//  export const APP_BASE_URL = 'http://localhost:8000';
//  export const APP_BASE_URL = 'http://10.103.2.92:8000/';
 //export const APP_BASE_URL = 'http://10.103.2.58:8000';
 //export const APP_BASE_URL = 'http://10.103.2.92:8000';
//  export const APP_BASE_URL = 'http://10.200.7.102:8000';

// export const APP_BASE_URL = 'https://oneclick.switchmobilityev.com/api';
//export const APP_BASE_URL = 'http://10.103.2.155:8000';
export const LEAVE_LIST = APP_BASE_URL + `/leave/leaveList`;
export const LEAVE_DETAILS = APP_BASE_URL + `/leave/approveLeave`
export const LEAVE_APPROVE = APP_BASE_URL + `/leave/approveLeave`
export const ASSERT_CREATE = APP_BASE_URL + `/assetrequest/createasset`
export const ASSERT_LIST = APP_BASE_URL + `/assetrequest/getasset`
export const ASSERT_REQUEST_LIST = APP_BASE_URL + `/assetrequest/getrequest`
export const ASSERT_REQUEST = APP_BASE_URL + `/assetrequest/request`
export const VENDOR_MASTER_INSERT = APP_BASE_URL + `/assetrequest/vendormaster`
export const VENDOR_MASTER_INSERT_RENEW = APP_BASE_URL + `/assetrequest/vendormasterenew`
export const VENDOR_MASTER_INSERT_USER = APP_BASE_URL + `/assetrequest/userupdate`
export const VENDOR_MASTER_INACTIVE = APP_BASE_URL + `/assetrequest/vendormaster_inactive`
export const GET_SAVEDVENDOR = APP_BASE_URL + `/assetrequest/getvendormaster`
export const ASSERT_ASSIGN = APP_BASE_URL + `/assetrequest/assignasset`
export const LEAVE_CREATE = APP_BASE_URL + `/leave/createLeave` 
export const USER_CREATION = APP_BASE_URL + `/registration/createusers`
export const LEAVE_USER_INFO = APP_BASE_URL + `/leave/userInfo`
export const LEAVE_LIST_ALL = APP_BASE_URL + `/leave/fetchAllLeave`
export const CREATE_USB_ACCESS = APP_BASE_URL + `/usbaccess/usb`
export const CREATE_SOFTWARE_ACCESS = APP_BASE_URL + `/softwareaccess/insert`
export const CREATE_COMMISSIONREPORT = APP_BASE_URL + `/eol/insertcommissionrp`
export const GET_HARNESSDATA = APP_BASE_URL + `/eol/getharnessdata`
export const GET_COMMISSIONDATA = APP_BASE_URL + `/eol/getcommissiondata`
export const GET_FETCHHVDATA = APP_BASE_URL + `/eol/fetchhvdata`
export const GET_FETCHLVDATA = APP_BASE_URL + `/eol/fetchlvdata`
export const GET_LVCONNECTORSAVEDDATA = APP_BASE_URL + `/eol/getlvconnectordata`
export const GET_BONDINGSAVEDDATA = APP_BASE_URL + `/eol/getbondingdata`
export const GET_LVCONNECTOR_EACH = APP_BASE_URL + `/eol/getlvconnectoreach`
export const GET_BONDING_EACH = APP_BASE_URL + `/eol/getbondingeach`
export const GET_FETCHLVCONDATA = APP_BASE_URL + `/eol/fetchlvcondata`
export const GET_FETCHBONDINGDATA = APP_BASE_URL + `/eol/fetchbondingdata`
export const CREATE_TEST_ENTRY = APP_BASE_URL + `/eol/testentry`
export const CREATE_LV_CONNECTOR = APP_BASE_URL + `/eol/connectorlventry`
export const CREATE_ISOLATIONTEST = APP_BASE_URL + `/eol/isolationtest`
export const GET_HARNESSDATA_EACH= APP_BASE_URL + `/eol/eachharness`
export const CREATE_BONDING=APP_BASE_URL + `/eol/bondingentry`
export const GET_ISOLATION_EACH=APP_BASE_URL + `/eol/isolationeach`
export const GET_ISOLATIONSAVEDDATA = APP_BASE_URL + `/eol/getisolationdata`
export const VIEW_TIMEENTRY = APP_BASE_URL + `/timesheet/view`
export const APPROVAL_TIMEENTRY = APP_BASE_URL + `/timesheet/approvalreq`
export const SUBMIT_TIMEENTRY = APP_BASE_URL + `/timesheet/insert`
export const GET_APPROVAL_TIMEENTRY = APP_BASE_URL + `/timesheet/approval`
export const REJECT_TIMEENTRY = APP_BASE_URL + `/timesheet/approvalrej`
export const GET_MANAGERID = APP_BASE_URL + `/userdata/userlist`
export const GET_VENDORMANAGERID = APP_BASE_URL + `/userdata/vendoruserlist`
export const CREATE_VPN_ACCESS=APP_BASE_URL + `/vpn/request`
export const GET_POWERTOKEN=APP_BASE_URL + `/powerbi/gettoken`
export const ACCESSVENDOR=APP_BASE_URL + `/access/login`
export const UPDATEMOBILE=APP_BASE_URL + `/access/update`
export const TEMPUSER=APP_BASE_URL + `/access/temp`
export const VENDORLOGINS=APP_BASE_URL + `/access/vendorlogin`
export const DOWNLOAD_TIMESHEET=APP_BASE_URL + `/timesheet/getdownload`
export const CREATE_EXTERNAL_ACCESS=APP_BASE_URL + `/external/insert`
export const GET_VENDORLIST=APP_BASE_URL + `/assetrequest/getvendorlist`
export const GET_SWITCHCODE=APP_BASE_URL + `/assetrequest/getvendorcode`
export const GET_WORKLOCATION=APP_BASE_URL + `/assetrequest/getlocationdata`
export const GET_DEPARTMENT=APP_BASE_URL + `/assetrequest/getdepartmentdata`
export const GET_RMNAME=APP_BASE_URL + `/assetrequest/rmsearch`
export const GET_SWITCHCODEDATA=APP_BASE_URL + `/assetrequest/codesearch`
export const GET_SWITCHEMPDATA=APP_BASE_URL + `/assetrequest/getempdata`
export const POSTFILES=APP_BASE_URL + `/assetrequest/postdata`
export const PANFILES=APP_BASE_URL + `/assetrequest/panfile`
export const NDAFILES=APP_BASE_URL + `/assetrequest/ndafile`
export const CTCFILES=APP_BASE_URL + `/assetrequest/ctcfile`
export const OFFERFILES=APP_BASE_URL + `/assetrequest/offerfile`
export const GROSSFILES=APP_BASE_URL + `/assetrequest/grossfile`
export const POSTDESPFILES=APP_BASE_URL + `/assetrequest/despfile`
export const GETFILES=APP_BASE_URL + `/assetrequest/getdata`
export const GETFILESPAN=APP_BASE_URL + `/assetrequest/getdatapan`
export const GETFILESNDA=APP_BASE_URL + `/assetrequest/getdatanda`
export const GETFILESOFFER=APP_BASE_URL + `/assetrequest/getdataoffer`
export const SENTMAILAGAIN=APP_BASE_URL + `/assetrequest/mailsend`
export const VENDOR_MASTER_VENDOR=APP_BASE_URL + `/assetrequest/vendor`
export const VENDORNRDFILES=APP_BASE_URL + `/assetrequest/vedornrd`
export const GSTFILES=APP_BASE_URL + `/assetrequest/gstfile` 
export const PROFESSTAX=APP_BASE_URL + `/assetrequest/Professtax`
export const LOCALTRADELICENSES=APP_BASE_URL + `/assetrequest/localtrade`
export const COMMSTAXREG=APP_BASE_URL + `/assetrequest/commstax`
export const ESIREGFILES=APP_BASE_URL + `/assetrequest/esireg`
export const CONTRACTLABREG=APP_BASE_URL + `/assetrequest/contrlabreg`
export const DEED=APP_BASE_URL + `/assetrequest/deed`
export const PARTNERSHIPREG=APP_BASE_URL + `/assetrequest/partnership`
export const AMENDEDFILES=APP_BASE_URL + `/assetrequest/amended`
export const LLPAGREEFILES=APP_BASE_URL + `/assetrequest/llp`
export const COPYOFPOAFILES=APP_BASE_URL + `/assetrequest/copyofpoa`
export const MOAFILES=APP_BASE_URL + `/assetrequest/moa`
export const ASSOCIATIONFILES=APP_BASE_URL + `/assetrequest/association`
export const COMMENCEFILES=APP_BASE_URL + `/assetrequest/commence`
export const CONTRACTPROPOSALFILES=APP_BASE_URL + `/assetrequest/contractproposal`
export const CALLCONTRACTAPI=APP_BASE_URL + `/assetrequest/contractapis`
export const GET_VENDORUSERDATA=APP_BASE_URL + `/assetrequest/getvendoruserdata` 
export const CERTICORPFILES=APP_BASE_URL + `/assetrequest/certicrop`
export const VENDORAGREEFILES=APP_BASE_URL + `/assetrequest/vendoragree`
export const VENDORPANFILES=APP_BASE_URL + `/assetrequest/vendorpan`
export const POSTPARTFILES=APP_BASE_URL + `/assetrequest/partfile`
export const REJECTDATASHARING=APP_BASE_URL + `/external/reject`
export const LINKDATASHARING=APP_BASE_URL + `/external/mailack`
export const DOWNLOAD_VENDORDATA=APP_BASE_URL + `/assetrequest/downloadreport`
export const GET_SAVEDSOFTWAREREQ=APP_BASE_URL + `/softwareaccess/getdata`
export const VAVE = APP_BASE_URL + "/vave/"
export const GETIDEACATEGORY = "getideacategory"
export const GETIDEAEFFECTIVEAGGREGATE = "getideaeffectiveaggre"
export const GETDOMAIN = "getdomain"
export const GETLOCATION = "getlocation"
export const GETMODEL = "getmodel"
export const SAVEIDEAGENERATION = "saveidea"
export const GETSAVEIDEAFORCOUNT = "getsaveidea"
export const GETSAVEIDEABYEMPID = "getsaveideabyempid?emp_id="
export const GETAPPROVEDIDEA = "getapprovedidea"
export const SAVEAUDITLOGS =APP_BASE_URL + "/assetrequest/createauditlogs"
export const IL1APPROVEBYPD = "approveil1"
export const IL1APPROVEBYSOURCING = "approveil1sourcing"
export const GETIL1PDDATABYEMPID = "getil1pddata?emp_id="
export const GETIL1SOURCINGDATABYEMPID = "getil1sourcingdata?emp_id="
export const GETIL1PDFILTERDATA = "getil1filterdatapd"
export const GETIL1SOURCINGFILTERDATA= "getil1filterdatasourcing"
export const REASSIGNIL1SOURCING= "reassignil1sourcing"
export const REASSIGNIL1PD= "reassignil1pd"
export const GETREASSIGNIL1PDLIST= "getuserassignedil1"
export const GETREASSIGNIL1PDLISTSOURCING= "getuserassignedil1sourcing"
export const GETIL2BYEMPID= "getil2data"
export const GETIL1= "getil1dataadmin"
export const IL2APPROVAL= "approveil2"
export const GET2B2DATA= "list2b2data"
export const UPLOAD2B2FILE= "upload2b2"
export const DOWNLOAD2B2FILE= "get2b2files"
export const GETTDEATESTINGDATA= "getideatesting"
export const TESTINGAPPROVE= "approvetesting"
export const GETIL4DATA= "getil4data"
export const APPROVEIL4DATA= "approveil4databypd"
export const APPROVEIL4QUALITYDATA= "approveil4databyquality"
export const DOWNLOADUPLOADEDUSERFILE= "getideauploadedfiles"
export const DOWNLOADIDEABYID= "downloadideabyid"
export const GETIL5DATA= "getil5data"
export const UPLOADIL5FILE= "uploadil5"
export const DOWNLOADIL5FILE= "getil5files"
export const CHECKEDIL5= "checkedil5"
export const APPROVEDIL5= "approvedil5"
export const ADMINUPDATEIL2= "adminupdateil2"
export const EXITREQUEST = APP_BASE_URL + `/assetrequest/employeexit`
export const GET_SEPERATIONDATA = APP_BASE_URL + `/assetrequest/seperationlist`
export const GET_SEPERATIONDATALL = APP_BASE_URL + `/assetrequest/seperationlistall`
export const GET_SEPERATIONDATATOTAL = APP_BASE_URL + `/assetrequest/seperationlisttotal`
export const GET_SEPERATIONDATADMIN = APP_BASE_URL + `/assetrequest/seperationlistadmin`
export const GET_SEPERATIONDATARM = APP_BASE_URL + `/assetrequest/seperationlistrm`
export const NOCIT = APP_BASE_URL + `/assetrequest/nocit`
export const NOCADMIN = APP_BASE_URL + `/assetrequest/nocadmin`
export const NOCRM = APP_BASE_URL + `/assetrequest/nocrm`
export const GET_SAVEDUSBREQUEST = APP_BASE_URL + `/usbaccess/getdata`
export const REJECTUSB = APP_BASE_URL + `/usbaccess/rejectusb`
export const GSTFILESVENDOR=APP_BASE_URL + `/vendorrequest/gstfilesvendor`
export const INCORPORATIONFILES=APP_BASE_URL + `/vendorrequest/incorporationfilesvendor`
export const PANFILESVENDOR=APP_BASE_URL + `/vendorrequest/panfilesvendor`
export const ITDCFILESVENDOR=APP_BASE_URL + `/vendorrequest/itdcfilesvendor`
export const SMEFILESVENDOR=APP_BASE_URL + `/vendorrequest/smefilesvendor`
export const BANKFILESVENDOR=APP_BASE_URL + `/vendorrequest/bankfilesvendor`
export const CREATE_VENDOR_ACCESS_DATA=APP_BASE_URL + `/vendorrequest/createvendoraccess`
export const GET_SAVEDVENDORREQ=APP_BASE_URL + `/vendorrequest/savedata`
export const GET_CERTIFICATE_FILES=APP_BASE_URL + `/vendorrequest/certificateincrop`
export const GET_PAN_FILES=APP_BASE_URL + `/vendorrequest/pan`
export const GET_ITDC_FILES=APP_BASE_URL + `/vendorrequest/getitdc`
export const GET_SME_FILES=APP_BASE_URL + `/vendorrequest/getsme`
export const GET_GST_FILES=APP_BASE_URL + `/vendorrequest/getgst`
export const GET_BANK_FILES=APP_BASE_URL + `/vendorrequest/getbank`
export const EDIT_VENDOR_ACCESS_DATA=APP_BASE_URL  + `/vendorrequest/editdata`
export const CREATE_PPR= APP_BASE_URL + `/assetrequest/createppr`
export const UPDATEPPRDATA= APP_BASE_URL + `/assetrequest/updateppr`
export const PPRFILES=APP_BASE_URL + `/assetrequest/exceldata`
export const GET_SAVEDPPR = APP_BASE_URL + `/assetrequest/getpprdata`
export const GETPPRFILE=APP_BASE_URL + `/assetrequest/getpprdatafile`
export const GETTOKEN=APP_BASE_URL + `/assetrequest/public-key`
export const NEWLOGIN =APP_BASE_URL + `/assetrequest/newlogin`
// SWITCH GEAR
export const ADD_PRODUCTS = APP_BASE_URL + `/products/addproducts`
export const UPDATE_PRODUCTS = APP_BASE_URL + `/products/updateproducts`
export const DELETE_PRODUCTS = APP_BASE_URL + `/products/deleteproducts`
export const GET_PRODUCTS = APP_BASE_URL + `/products/getproducts`
// export const SHOW_PRODUCTS = APP_BASE_URL + `/products/showproducts`
export const ADD_CART_PRODUCTS = APP_BASE_URL + `/products/addcartproducts`
export const DELETE_CART_PRODUCTS = APP_BASE_URL + `/products/deletecartproducts`
export const GET_CART_PRODUCTS = APP_BASE_URL + `/products/getcartproducts`
// USER :
export const PURCHASE_PRODUCTS = APP_BASE_URL + `/products/purchaseproducts`
export const GET_GRANTED_PRODUCTS = APP_BASE_URL + "/products/grantedproducts";
export const GET_REQUESTED_PRODUCTS = APP_BASE_URL + "/products/requestedproducts";
// FUNCTIONAL :
export const GET_FUNCTIONAL_REQUESTED_PRODUCTS = APP_BASE_URL + "/products/functionalrequestedproducts";
export const ACCEPT_FUNCTIONAL_REQUESTED_PRODUCTS = APP_BASE_URL + "/products/functionalacceptrequestedproducts"
export const REJECT_FUNCTIONAL_REQUESTED_PRODUCTS = APP_BASE_URL + "/products/functionalrejectrequestedproducts"
// ADMIN :
export const GET_ADMIN_REQUESTED_PRODUCTS = APP_BASE_URL + "/products/adminrequestedproducts";
export const ACCEPT_ADMIN_REQUESTED_PRODUCTS = APP_BASE_URL + "/products/adminacceptrequestedproducts"
export const REJECT_ADMIN_REQUESTED_PRODUCTS = APP_BASE_URL + "/products/adminrejectrequestedproducts"
// ISSUER :
export const GET_ISSUER_REQUESTED_PRODUCTS = APP_BASE_URL + "/products/issuerrequestedproducts";
export const ACKNOWLEDGE_ISSUER_REQUESTED_PRODUCTS = APP_BASE_URL + "/products/issueracknowledgerequestedproducts"
// ACKNOWLEDGE :
export const ACKNOWLEDGE_USER_REQUESTED_PRODUCTS = APP_BASE_URL + "/products/useracknowledgerequestedproducts"
// GRANTED :
export const GET_FUNCTIONAL_GRANTED_PRODUCTS = APP_BASE_URL + "/products/functionalgrantedproducts";
export const GET_ADMIN_GRANTED_PRODUCTS = APP_BASE_URL + "/products/admingrantedproducts";
export const GET_ISSUER_GRANTED_PRODUCTS = APP_BASE_URL + "/products/issuergrantedproducts";
// GET REPORTING MANAGER :
export const GET_REPORTING_MANAGER = APP_BASE_URL + "/products/findreportingmanager";
// SWIPE X
export const GET_USER_DETAILS = APP_BASE_URL + "/swipex/getuserdetails";
export const GET_SWIPEX_DETAILS = APP_BASE_URL + "/swipex/getswipexdetails";
export const SUBMIT_REQUEST = APP_BASE_URL + "/swipex/addcontinualimprovement";
export const UPDATE_REQUEST = APP_BASE_URL + "/swipex/updatecontinualimprovement";

export const GET_USER_ALL_CI = APP_BASE_URL + "/swipex/getuserallci";
export const GET_USER_SUBMITTED_CI = APP_BASE_URL + "/swipex/getusersubmittedci";
export const GET_USER_UPDATES_CI = APP_BASE_URL + "/swipex/getuserupdatesci";
export const GET_USER_ACCEPTED_CI = APP_BASE_URL + "/swipex/getuseracceptedci";
export const GET_USER_REJECTED_CI = APP_BASE_URL + "/swipex/getuserrejectedci";

// VALIDATOR
export const GET_VALIDATOR_ALL_CI = APP_BASE_URL + "/swipex/getvalidatorallci";
export const GET_VALIDATOR_SUBMITTED_CI = APP_BASE_URL + "/swipex/getvalidatorsubmittedci";
export const GET_VALIDATOR_UPDATES_CI = APP_BASE_URL + "/swipex/getvalidatorupdatesci";
export const GET_VALIDATOR_ACCEPTED_CI = APP_BASE_URL + "/swipex/getvalidatoracceptedci";
export const GET_VALIDATOR_REJECTED_CI = APP_BASE_URL + "/swipex/getvalidatorrejectedci";
export const ACCEPT_VALIDATOR_CI = APP_BASE_URL + "/swipex/acceptvalidatorci";
export const REJECT_VALIDATOR_CI = APP_BASE_URL + "/swipex/rejectvalidatorci";
export const EDIT_VALIDATOR_CI = APP_BASE_URL + "/swipex/editvalidatorci";
// APPROVER
export const GET_APPROVER_ALL_CI = APP_BASE_URL + "/swipex/getapproverallci";
export const GET_APPROVER_SUBMITTED_CI = APP_BASE_URL + "/swipex/getapproversubmittedci";
export const GET_APPROVER_UPDATES_CI = APP_BASE_URL + "/swipex/getapproverupdatesci";
export const GET_APPROVER_ACCEPTED_CI = APP_BASE_URL + "/swipex/getapproveracceptedci";
export const GET_APPROVER_REJECTED_CI = APP_BASE_URL + "/swipex/getapproverrejectedci";
export const GET_APPROVER_TRACK_CI = APP_BASE_URL + "/swipex/getapprovertrackci";
export const ACCEPT_APPROVER_CI = APP_BASE_URL + "/swipex/acceptapproverci";
export const REJECT_APPROVER_CI = APP_BASE_URL + "/swipex/rejectapproverci";
export const EDIT_APPROVER_CI = APP_BASE_URL + "/swipex/editapproverci";
export const NOCUSERS = APP_BASE_URL + "/assetrequest/nocuser";
